<template>
    <div class="configure-cart-item-unit">
        <div class="measurements__info py-3">
            <p class="is-size-5 has-text-grey">
                {{ $t('checkout.configure.objectMeasurements') }}
            </p>
            <strong class="has-text-grey-dark"
                >{{ printFile.analysedProperties.dimensions.X.toFixed(2) }} x
                {{ printFile.analysedProperties.dimensions.Y.toFixed(2) }} x
                {{
                    printFile.analysedProperties.dimensions.Z.toFixed(2)
                }}</strong
            >
        </div>

        <p class="is-size-5 has-text-grey">
            {{ $t('checkout.configure.inputLabels.givenUnitOfLength') }}
        </p>
        <div class="py-3 has-text-primary">
            <b-radio
                v-model="fileUnit"
                native-value="mm"
                class="mr-6 has-text-black"
            >
                MM
            </b-radio>
            <b-radio
                v-model="fileUnit"
                native-value="cm"
                class="mr-6 has-text-black"
            >
                CM
            </b-radio>
            <b-radio
                v-model="fileUnit"
                native-value="inch"
                class="mr-6 has-text-black"
            >
                INCH
            </b-radio>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'ConfigureLengthUnit',
    props: {
        printFileId: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapGetters(['printFileById']),
        fileUnit: {
            get() {
                return this.printFile.givenUnitOfLength;
            },
            set(value) {
                this.$store.dispatch('update3DFile', {
                    id: this.printFileId,
                    givenUnitOfLength: value,
                });
            },
        },
        printFile() {
            return this.printFileById(this.printFileId);
        },
    },
};
</script>
